export const projectsKpi = [
  {
    project_guid: "f3b1d569-688c-4756-fc75-ecdd332b3147",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.2,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.080955499,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.409288974,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.38489261,
    mission_indicator_trend: 1,
    data_reliability_color: 1.428858619,
    data_reliability_trend: 0,
  },
  {
    project_guid: "cf344fa3-2497-b57f-489a-dd77068c77ff",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.822009631,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.847169509,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.90086106,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.028419974,
    mission_indicator_trend: 0,
    data_reliability_color: 3.511587982,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b250c591-6837-1010-2906-15befec3d292",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.023907503,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.501394445,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.122601423,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.453049426,
    mission_indicator_trend: 0,
    data_reliability_color: 3.018584719,
    data_reliability_trend: 0,
  },
  {
    project_guid: "6910fba4-f427-eea0-bf5a-2c67edd88589",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.30691742,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.194455053,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.424805148,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.307343349,
    mission_indicator_trend: -1,
    data_reliability_color: 3.301066131,
    data_reliability_trend: 0,
  },
  {
    project_guid: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.688843642,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.7870485,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.622314074,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.42400083,
    mission_indicator_trend: 0,
    data_reliability_color: 3.922011165,
    data_reliability_trend: 0,
  },
  {
    project_guid: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.862309949,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.424163338,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.818384279,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.459154239,
    mission_indicator_trend: -1,
    data_reliability_color: 2.747537941,
    data_reliability_trend: 1,
  },
  {
    project_guid: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.156801823,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.138674263,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.964966488,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.99814607,
    mission_indicator_trend: 0,
    data_reliability_color: 1.525420472,
    data_reliability_trend: 1,
  },
  {
    project_guid: "23ecf456-a7f5-a4de-f448-d94c04843c84",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.552178205,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.167482535,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.20288483,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.350532104,
    mission_indicator_trend: 1,
    data_reliability_color: 2.487813349,
    data_reliability_trend: 0,
  },
  {
    project_guid: "8b5921c6-9d15-f318-c136-acb492469ab7",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.94525344,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.991237777,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.951784984,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.984982061,
    mission_indicator_trend: 0,
    data_reliability_color: 2.853008939,
    data_reliability_trend: -1,
  },
  {
    project_guid: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.672718823,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.870370698,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.069142454,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.006726976,
    mission_indicator_trend: 1,
    data_reliability_color: 3.744635164,
    data_reliability_trend: 0,
  },
  {
    project_guid: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.023885194,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.347830883,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.384115776,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.381585565,
    mission_indicator_trend: 1,
    data_reliability_color: 2.982008551,
    data_reliability_trend: -1,
  },
  {
    project_guid: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.271417191,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.494595907,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.946584387,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.829304733,
    mission_indicator_trend: 1,
    data_reliability_color: 1.815183736,
    data_reliability_trend: 1,
  },
  {
    project_guid: "0f995026-ec95-2d71-5c89-868b1e1547ff",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.376258694,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.569173241,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.704585199,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.430719181,
    mission_indicator_trend: -1,
    data_reliability_color: 3.800557156,
    data_reliability_trend: -1,
  },
  {
    project_guid: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.25348092,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.887673106,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.565588991,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.044897403,
    mission_indicator_trend: 0,
    data_reliability_color: 2.515764182,
    data_reliability_trend: -1,
  },
  {
    project_guid: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.88093603,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.553488303,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.107866813,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.089777944,
    mission_indicator_trend: -1,
    data_reliability_color: 3.772611059,
    data_reliability_trend: 0,
  },
  {
    project_guid: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.395882937,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.527874233,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.553856993,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.075603105,
    mission_indicator_trend: 0,
    data_reliability_color: 2.426197415,
    data_reliability_trend: -1,
  },
  {
    project_guid: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.004463505,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.769717212,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.07564415,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.976906233,
    mission_indicator_trend: 1,
    data_reliability_color: 3.195586424,
    data_reliability_trend: 1,
  },
  {
    project_guid: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.744498625,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.947975347,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.145551689,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.09719186,
    mission_indicator_trend: -1,
    data_reliability_color: 3.787275603,
    data_reliability_trend: 1,
  },
  {
    project_guid: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.970156312,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.90346578,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.722284658,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.599911503,
    mission_indicator_trend: 1,
    data_reliability_color: 3.654963308,
    data_reliability_trend: 1,
  },
  {
    project_guid: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.302570595,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.123833978,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.466693804,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.285170229,
    mission_indicator_trend: -1,
    data_reliability_color: 3.334584367,
    data_reliability_trend: 1,
  },
  {
    project_guid: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.097248211,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.059874628,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.138502313,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.012209474,
    mission_indicator_trend: 0,
    data_reliability_color: 1.178406428,
    data_reliability_trend: 1,
  },
  {
    project_guid: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.022568413,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.593581216,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.991494854,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.628349524,
    mission_indicator_trend: 0,
    data_reliability_color: 1.876848059,
    data_reliability_trend: 0,
  },
  {
    project_guid: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.467902153,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.832756167,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.06937603,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.644931929,
    mission_indicator_trend: 1,
    data_reliability_color: 2.324544486,
    data_reliability_trend: 0,
  },
  {
    project_guid: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.578852645,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.209328247,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.088667681,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.249018998,
    mission_indicator_trend: 0,
    data_reliability_color: 1.768395654,
    data_reliability_trend: 0,
  },
  {
    project_guid: "09758415-c112-23a3-e351-0a962d07e9bf",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.96993976,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.308722539,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.661876223,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.524395462,
    mission_indicator_trend: 0,
    data_reliability_color: 1.384764816,
    data_reliability_trend: 0,
  },
  {
    project_guid: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.712713285,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.171898383,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.337810268,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.239213118,
    mission_indicator_trend: 0,
    data_reliability_color: 2.101931374,
    data_reliability_trend: 0,
  },
  {
    project_guid: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.497931068,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.114377961,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.238772918,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.660096026,
    mission_indicator_trend: 0,
    data_reliability_color: 3.978477367,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.388506842,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.863119365,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.184153945,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.98179978,
    mission_indicator_trend: 1,
    data_reliability_color: 3.52495428,
    data_reliability_trend: 0,
  },
  {
    project_guid: "6c632848-4365-9cc9-6d3e-98b0966204e1",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.013357506,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.241582908,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.09557528,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.762890068,
    mission_indicator_trend: 1,
    data_reliability_color: 2.953381769,
    data_reliability_trend: 1,
  },
  {
    project_guid: "0b698afd-36c6-4235-9402-a2857a687c72",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.410821592,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.769456317,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.502603801,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.948017743,
    mission_indicator_trend: 0,
    data_reliability_color: 3.423208508,
    data_reliability_trend: -1,
  },
  {
    project_guid: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.526663138,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.079807572,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.341973688,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.48052785,
    mission_indicator_trend: 0,
    data_reliability_color: 3.20434344,
    data_reliability_trend: 0,
  },
  {
    project_guid: "31a15793-a76e-d05e-8807-f79871ea0eed",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.905786419,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.331918634,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.793255205,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.271328908,
    mission_indicator_trend: 0,
    data_reliability_color: 1.226642928,
    data_reliability_trend: 1,
  },
  {
    project_guid: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.052760413,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.247051033,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.9079924,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.794596947,
    mission_indicator_trend: 1,
    data_reliability_color: 2.26140127,
    data_reliability_trend: 0,
  },
  {
    project_guid: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.839608005,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.503776122,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.861501625,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.009585772,
    mission_indicator_trend: 0,
    data_reliability_color: 3.983568503,
    data_reliability_trend: -1,
  },
  {
    project_guid: "3992f128-09f6-9021-4634-d7804c356132",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.56144684,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.514944762,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.768451871,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.557446856,
    mission_indicator_trend: -1,
    data_reliability_color: 3.40494387,
    data_reliability_trend: 0,
  },
  {
    project_guid: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.505855678,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.340113763,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.324387394,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.48896925,
    mission_indicator_trend: 1,
    data_reliability_color: 2.869952305,
    data_reliability_trend: 0,
  },
  {
    project_guid: "84530e7d-f865-267a-4337-a72285000773",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.671586881,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.864606124,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.390004205,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.229923273,
    mission_indicator_trend: 1,
    data_reliability_color: 1.201813922,
    data_reliability_trend: 0,
  },
  {
    project_guid: "176df13d-87bc-ae46-4373-2d93129d5f9d",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.17846645,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.568936332,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.805803748,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.33623936,
    mission_indicator_trend: 1,
    data_reliability_color: 2.002886358,
    data_reliability_trend: 1,
  },
  {
    project_guid: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.271060991,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.154553436,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.727435234,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.752729736,
    mission_indicator_trend: -1,
    data_reliability_color: 3.449525559,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b112cc5a-7e35-091d-7614-bd760a27cf58",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.965345206,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.336588201,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.95816317,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.65973271,
    mission_indicator_trend: -1,
    data_reliability_color: 1.906896744,
    data_reliability_trend: 0,
  },
  {
    project_guid: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.753497685,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.619400666,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.066487912,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.109826487,
    mission_indicator_trend: 1,
    data_reliability_color: 1.218275673,
    data_reliability_trend: -1,
  },
  {
    project_guid: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.420089717,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.511731759,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.995867609,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.040297729,
    mission_indicator_trend: -1,
    data_reliability_color: 2.132461771,
    data_reliability_trend: -1,
  },
  {
    project_guid: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.689677745,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.708862824,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.577400052,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.157210285,
    mission_indicator_trend: 1,
    data_reliability_color: 2.315237819,
    data_reliability_trend: 1,
  },
  {
    project_guid: "278ba0df-615b-ed80-b6fd-de88571ba826",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.335959814,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.949962271,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.311638417,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.793906964,
    mission_indicator_trend: 1,
    data_reliability_color: 2.288331605,
    data_reliability_trend: 0,
  },
  {
    project_guid: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.210098264,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.303441158,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.976774716,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.752314051,
    mission_indicator_trend: 0,
    data_reliability_color: 1.807863131,
    data_reliability_trend: 0,
  },
  {
    project_guid: "3b55fe73-9f71-b17b-5d4b-42820517364c",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.062785378,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.140129285,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.332908689,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.917831543,
    mission_indicator_trend: 0,
    data_reliability_color: 3.860271997,
    data_reliability_trend: 1,
  },
  {
    project_guid: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.301252753,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.960507204,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.737316932,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.357613558,
    mission_indicator_trend: -1,
    data_reliability_color: 1.149573316,
    data_reliability_trend: 1,
  },
  {
    project_guid: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.157002399,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.895269129,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.471169058,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.82868506,
    mission_indicator_trend: 1,
    data_reliability_color: 1.43288635,
    data_reliability_trend: 1,
  },
  {
    project_guid: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.419334257,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.328739212,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.299230377,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.25819417,
    mission_indicator_trend: 0,
    data_reliability_color: 1.791173268,
    data_reliability_trend: 1,
  },
  {
    project_guid: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.247222131,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.23427776,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.028460287,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.836899394,
    mission_indicator_trend: 0,
    data_reliability_color: 2.889251084,
    data_reliability_trend: -1,
  },
  {
    project_guid: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.030801596,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.668223427,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.85942738,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.150262358,
    mission_indicator_trend: 0,
    data_reliability_color: 3.44529322,
    data_reliability_trend: 0,
  },
  {
    project_guid: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.269356197,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.890505653,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.005051899,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.218708406,
    mission_indicator_trend: -1,
    data_reliability_color: 3.96315883,
    data_reliability_trend: 1,
  },
  {
    project_guid: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.050921453,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.398131106,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.102768797,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.370993269,
    mission_indicator_trend: 0,
    data_reliability_color: 2.33179264,
    data_reliability_trend: 1,
  },
  {
    project_guid: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.839895106,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.842634058,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.950538888,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.980798795,
    mission_indicator_trend: 0,
    data_reliability_color: 1.585608683,
    data_reliability_trend: 1,
  },
  {
    project_guid: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.242263142,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.805718424,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.422823207,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.866686943,
    mission_indicator_trend: 0,
    data_reliability_color: 3.873823995,
    data_reliability_trend: 0,
  },
  {
    project_guid: "93ceaf79-3504-618b-3caa-148553fc5ade",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.933898098,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.800679444,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.413806481,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.248612989,
    mission_indicator_trend: -1,
    data_reliability_color: 2.272493479,
    data_reliability_trend: 0,
  },
  {
    project_guid: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.450288609,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.453329279,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.409472203,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.474823958,
    mission_indicator_trend: -1,
    data_reliability_color: 2.463528996,
    data_reliability_trend: 0,
  },
  {
    project_guid: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.952904062,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.401822809,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.06911705,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.72791624,
    mission_indicator_trend: -1,
    data_reliability_color: 2.612760149,
    data_reliability_trend: 0,
  },
  {
    project_guid: "cee95d82-f046-532c-07cb-937090ac28cc",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.009643037,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.049860382,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.980340392,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.237010916,
    mission_indicator_trend: -1,
    data_reliability_color: 1.771360458,
    data_reliability_trend: 0,
  },
  {
    project_guid: "a2d99805-73f0-c858-b709-fbda2482cfcd",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.491495079,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.229902758,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.666381368,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.51859778,
    mission_indicator_trend: 1,
    data_reliability_color: 1.551098411,
    data_reliability_trend: 1,
  },
  {
    project_guid: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.341378237,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.667387355,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.247609075,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.696602754,
    mission_indicator_trend: 0,
    data_reliability_color: 2.753913763,
    data_reliability_trend: 0,
  },
  {
    project_guid: "0f1714ac-cc77-e427-da57-3abacd8ef051",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.220692264,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.218650773,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.310808653,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.624567275,
    mission_indicator_trend: -1,
    data_reliability_color: 1.728742355,
    data_reliability_trend: -1,
  },
  {
    project_guid: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.938872748,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.411839872,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.958275231,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.071477897,
    mission_indicator_trend: -1,
    data_reliability_color: 2.31389799,
    data_reliability_trend: -1,
  },
  {
    project_guid: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.429665287,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.128763134,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.00475046,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.775714217,
    mission_indicator_trend: 0,
    data_reliability_color: 1.809433338,
    data_reliability_trend: 0,
  },
  {
    project_guid: "5bcc188b-0578-f637-8984-92ea83d595b9",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.291268197,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.150127615,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.963206957,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.355385014,
    mission_indicator_trend: 0,
    data_reliability_color: 3.696353202,
    data_reliability_trend: -1,
  },
  {
    project_guid: "46227e4f-080e-401a-1262-5b9fe925eea4",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.329199367,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.996252603,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.463728681,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.425772083,
    mission_indicator_trend: 0,
    data_reliability_color: 2.431044101,
    data_reliability_trend: 1,
  },
  {
    project_guid: "05a02557-41a2-c677-13d5-a29c38fbb097",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.172311353,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.478189913,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.169168485,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.988726368,
    mission_indicator_trend: 1,
    data_reliability_color: 2.053160646,
    data_reliability_trend: 0,
  },
  {
    project_guid: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.942665698,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.67463095,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.077293365,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.329005926,
    mission_indicator_trend: 0,
    data_reliability_color: 1.689732551,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.405944021,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.030195959,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.740956384,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.371702402,
    mission_indicator_trend: 1,
    data_reliability_color: 1.48092134,
    data_reliability_trend: 0,
  },
  {
    project_guid: "91824670-8112-92d4-207f-6e53e569077e",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.561435243,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.07364919,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.948291367,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.54121482,
    mission_indicator_trend: -1,
    data_reliability_color: 1.682585597,
    data_reliability_trend: 0,
  },
  {
    project_guid: "e6679fbf-a152-90b6-85af-25a473c75793",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.406060205,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.895544773,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.052399101,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.961412411,
    mission_indicator_trend: 1,
    data_reliability_color: 2.714884534,
    data_reliability_trend: 0,
  },
  {
    project_guid: "0f3e99cd-4b01-7991-e96b-46284f930562",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.637197044,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.71674336,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.683033649,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.695806326,
    mission_indicator_trend: -1,
    data_reliability_color: 3.453204841,
    data_reliability_trend: 0,
  },
  {
    project_guid: "27b3c82f-0697-2114-a665-88f73dee3105",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.59666876,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.666278134,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.061587201,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.713653452,
    mission_indicator_trend: 1,
    data_reliability_color: 2.945156253,
    data_reliability_trend: 1,
  },
  {
    project_guid: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.9857878,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.879053294,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.288268307,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.429693127,
    mission_indicator_trend: -1,
    data_reliability_color: 3.346136473,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.292251885,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.493760926,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.105568893,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.58552083,
    mission_indicator_trend: 1,
    data_reliability_color: 1.984156889,
    data_reliability_trend: 0,
  },
  {
    project_guid: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.445097259,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.45583396,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.974238642,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.879432802,
    mission_indicator_trend: 1,
    data_reliability_color: 2.470883633,
    data_reliability_trend: 1,
  },
  {
    project_guid: "d679d948-538e-b268-0696-367116749259",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.970264808,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.922626594,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.692977901,
    finance_indicator_trend: -1,
    mission_indicator_color: 3.514116993,
    mission_indicator_trend: 1,
    data_reliability_color: 1.751337744,
    data_reliability_trend: 0,
  },
  {
    project_guid: "18805689-9839-41a8-1929-4389263c8c14",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.369430922,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.772064235,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.978729814,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.535165292,
    mission_indicator_trend: -1,
    data_reliability_color: 2.191764346,
    data_reliability_trend: 0,
  },
  {
    project_guid: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.984217641,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.796514642,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.011652616,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.709199691,
    mission_indicator_trend: 0,
    data_reliability_color: 2.419503616,
    data_reliability_trend: 1,
  },
  {
    project_guid: "b366af47-9bc5-81eb-177a-23c48fbf7023",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.557323553,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.749757126,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.874064009,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.775194835,
    mission_indicator_trend: 0,
    data_reliability_color: 1.830278243,
    data_reliability_trend: 0,
  },
  {
    project_guid: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.454238903,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.720416363,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.77612332,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.14482419,
    mission_indicator_trend: 0,
    data_reliability_color: 3.175591741,
    data_reliability_trend: 0,
  },
  {
    project_guid: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.69900486,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.96844572,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.153550275,
    finance_indicator_trend: 0,
    mission_indicator_color: 1.251059758,
    mission_indicator_trend: -1,
    data_reliability_color: 2.422963687,
    data_reliability_trend: 0,
  },
  {
    project_guid: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.561929866,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.616734208,
    schedule_indicator_trend: 0,
    finance_indicator_color: 2.602630143,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.380193432,
    mission_indicator_trend: 0,
    data_reliability_color: 2.64816168,
    data_reliability_trend: -1,
  },
  {
    project_guid: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.290203847,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.501985617,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.718857051,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.642063294,
    mission_indicator_trend: 1,
    data_reliability_color: 2.297909426,
    data_reliability_trend: -1,
  },
  {
    project_guid: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.669048959,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.446562852,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.624706132,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.278142267,
    mission_indicator_trend: -1,
    data_reliability_color: 3.326784586,
    data_reliability_trend: 0,
  },
  {
    project_guid: "206340dc-04d2-206f-a9b1-0e22803e4d09",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.584295009,
    summary_indicator_trend: 0,
    schedule_indicator_color: 2.6034867,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.004960801,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.136815684,
    mission_indicator_trend: -1,
    data_reliability_color: 1.591916851,
    data_reliability_trend: -1,
  },
  {
    project_guid: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.648357457,
    summary_indicator_trend: 0,
    schedule_indicator_color: 1.976215088,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.029809484,
    finance_indicator_trend: -1,
    mission_indicator_color: 2.987942775,
    mission_indicator_trend: 1,
    data_reliability_color: 3.59946248,
    data_reliability_trend: 0,
  },
  {
    project_guid: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.485367152,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.999040081,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.731410068,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.361528889,
    mission_indicator_trend: 1,
    data_reliability_color: 3.849489571,
    data_reliability_trend: 1,
  },
  {
    project_guid: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 1.804928584,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.265505183,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.008381774,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.806290844,
    mission_indicator_trend: -1,
    data_reliability_color: 1.139536533,
    data_reliability_trend: -1,
  },
  {
    project_guid: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.057940015,
    summary_indicator_trend: 1,
    schedule_indicator_color: 1.196000156,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.301188112,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.191676528,
    mission_indicator_trend: 0,
    data_reliability_color: 2.542895265,
    data_reliability_trend: 1,
  },
  {
    project_guid: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.194365245,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.724510205,
    schedule_indicator_trend: 1,
    finance_indicator_color: 1.334291547,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.98716182,
    mission_indicator_trend: 1,
    data_reliability_color: 3.73149741,
    data_reliability_trend: 0,
  },
  {
    project_guid: "33574084-6584-9717-a9f7-1488f5d751e6",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.578942325,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.8158381,
    schedule_indicator_trend: -1,
    finance_indicator_color: 2.871886863,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.333105142,
    mission_indicator_trend: 0,
    data_reliability_color: 2.294939193,
    data_reliability_trend: -1,
  },
  {
    project_guid: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.599552076,
    summary_indicator_trend: -1,
    schedule_indicator_color: 2.937072473,
    schedule_indicator_trend: 0,
    finance_indicator_color: 1.935006395,
    finance_indicator_trend: 0,
    mission_indicator_color: 2.420328141,
    mission_indicator_trend: -1,
    data_reliability_color: 3.105801296,
    data_reliability_trend: 0,
  },
  {
    project_guid: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.115255281,
    summary_indicator_trend: -1,
    schedule_indicator_color: 1.824818483,
    schedule_indicator_trend: -1,
    finance_indicator_color: 1.585523546,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.415566087,
    mission_indicator_trend: -1,
    data_reliability_color: 2.635113009,
    data_reliability_trend: -1,
  },
  {
    project_guid: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.17052984,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.961679264,
    schedule_indicator_trend: 0,
    finance_indicator_color: 3.02801959,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.694194735,
    mission_indicator_trend: -1,
    data_reliability_color: 1.998225772,
    data_reliability_trend: -1,
  },
  {
    project_guid: "7073121b-3d14-c0b2-3032-607f156aca93",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.353545067,
    summary_indicator_trend: 0,
    schedule_indicator_color: 3.004630685,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.897325211,
    finance_indicator_trend: -1,
    mission_indicator_color: 1.327613762,
    mission_indicator_trend: -1,
    data_reliability_color: 1.18461061,
    data_reliability_trend: -1,
  },
  {
    project_guid: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.695440105,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.39491967,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.285901786,
    finance_indicator_trend: 1,
    mission_indicator_color: 2.677612147,
    mission_indicator_trend: 1,
    data_reliability_color: 3.423326818,
    data_reliability_trend: 0,
  },
  {
    project_guid: "0763b796-9b92-694a-3f48-e184c55865df",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 2.513061749,
    summary_indicator_trend: 1,
    schedule_indicator_color: 2.22319943,
    schedule_indicator_trend: 1,
    finance_indicator_color: 2.721219792,
    finance_indicator_trend: 1,
    mission_indicator_color: 1.155428302,
    mission_indicator_trend: 1,
    data_reliability_color: 3.952399472,
    data_reliability_trend: -1,
  },
  {
    project_guid: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.008737298,
    summary_indicator_trend: -1,
    schedule_indicator_color: 3.692722538,
    schedule_indicator_trend: -1,
    finance_indicator_color: 3.306598867,
    finance_indicator_trend: 0,
    mission_indicator_color: 3.345697046,
    mission_indicator_trend: 0,
    data_reliability_color: 1.689930742,
    data_reliability_trend: 0,
  },
  {
    project_guid: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
    reporting_date: "15-апр.-23",
    summary_indicator_color: 3.608251483,
    summary_indicator_trend: 1,
    schedule_indicator_color: 3.723623792,
    schedule_indicator_trend: 1,
    finance_indicator_color: 3.588545285,
    finance_indicator_trend: 1,
    mission_indicator_color: 3.83481774,
    mission_indicator_trend: 1,
    data_reliability_color: 3.686019115,
    data_reliability_trend: 1,
  },
];
